const initialState = {
  services: [
    {
      slug: 'hp-smart-tank-5000',
      cover: '/printers/5000.jpeg',
      thumbnail: '',
      title: 'HP Smart Tank 5000 Wireless All-in-One Ink Tank Printer',
      shortTitle: 'HP Smart Tank 5000 Wireless All-in-One Ink Tank Printer',
      price: 169,
      badge: '3 MONTHS',
      tags: ['High volume printing', 'Ethernet'],
      descrition:
        'HP Smart Tank 5000 Wireless All-in-One Ink Tank Printer, Scanner, Copier with 2 years of...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-laserjet-pro-m404dn',
      cover: '/printers/404dn.jpeg',
      thumbnail: '',
      title: 'HP LaserJet Pro M404dn Monochrome Laser Printer',
      shortTitle: 'HP LaserJet Pro M404dn Monochrome Laser Printer',
      price: 249,
      badge: '',
      tags: ['Print', 'Secure printing'],
      descrition:
        'Fast and reliable monochrome laser printer built for office productivity...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-envy-6555e',
      cover: '/printers/6555e.jpeg',
      thumbnail: '',
      title: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      shortTitle: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      price: 139,
      badge: '3 MONTHS',
      tags: ['Print', 'Scan', 'Copy'],
      descrition:
        'The Envy 6555e is perfect for home printing everyday documents, high quality photos, and...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-9025e',
      cover: '/printers/9025e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 9025e Wireless All-in-One Printer',
      shortTitle: 'HP OfficeJet Pro 9025e Wireless All-in-One Printer',
      price: 329,
      badge: '',
      tags: ['Duplex', 'Wireless'],
      descrition:
        'High-performance inkjet printer ideal for small offices with fast speeds and advanced security...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-color-laserjet-pro-mfp-3301fdw',
      cover: '/printers/3301.webp',
      thumbnail: '',
      title:
        'HP Color LaserJet Pro MFP 3301fdw Wireless All-in-One Color Laser Printer',
      shortTitle:
        'HP Color LaserJet Pro MFP 3301fdw Wireless All-in-One Color Laser Printer',
      price: 539,
      badge: '',
      tags: ['Color printing', 'Multiuse', 'Wireless'],
      descrition:
        'Introducing a MOST TRUSTED PRINTER BRAND — Perfect for small home printing, scanning and copying...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-8125e',
      cover: '/printers/8125e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 8125e Wireless All-in-One Color Inkjet Printer',
      shortTitle:
        'HP OfficeJet Pro 8125e Wireless All-in-One Color Inkjet Printer',
      price: 179,
      badge: '3 MONTHS',
      tags: ['Wireless printing', 'Multifunction', 'Compact design'],
      descrition:
        'The OfficeJet Pro 8125e is perfect for professional quality color documents like business...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'brother-work-smart-1360',
      cover: '/printers/1360.jpeg',
      thumbnail: '',
      title: 'Brother Work Smart 1360 Wireless Color Inkjet All-in-One Printer',
      shortTitle:
        'Brother Work Smart 1360 Wireless Color Inkjet All-in-One Printer',
      price: 109.99,
      badge: '',
      tags: ['Print', 'Copy', 'Scan'],
      descrition:
        'Get all your work done with an all-in-one multifunction printer. Print, copy, and scan...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-deskjet-4155e',
      cover: '/printers/4155e.jpeg',
      thumbnail: '',
      title: 'HP DeskJet 4155e Wireless All-in-One Printer',
      shortTitle: 'HP DeskJet 4155e Wireless All-in-One Printer',
      price: 99,
      badge: '',
      tags: ['Print', 'Scan', 'Copy', 'Print Printing'],
      descrition:
        'Affordable wireless printer designed for easy printing and scanning everyday...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-color-laserjet-pro-m255dw',
      cover: '/printers/m255d.jpeg',
      thumbnail: '',
      title: 'HP Color LaserJet Pro M255dw',
      shortTitle: 'HP Color LaserJet Pro M255dw',
      price: 389,
      badge: '',
      tags: ['Color Prnt', 'Wireless'],
      descrition:
        'Compact color laser printer delivering professional-quality color output...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-9015e',
      cover: '/printers/9015e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 9015e All-in-One Printer',
      shortTitle: 'HP OfficeJet Pro 9015e All-in-One Printer',
      price: 279.99,
      badge: '3 MONTHS',
      tags: ['Print', 'Scan', 'Copy', 'Fax'],
      descrition:
        'The OfficeJet Pro 9015e is perfect for office printing professional quality color documents like presentations, brochures, the homework and...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-8135e',
      cover: '/printers/3135e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 8135e Wireless All-in-One Color Inkjet Printer',
      shortTitle:
        'HP OfficeJet Pro 8135e Wireless All-in-One Color Inkjet Printer',
      price: 89.99,
      badge: '',
      tags: ['Wireless', 'Satellite printing'],
      descrition:
        'The OfficeJet Pro 8135e is perfect for home office printing professional quality color documents like business...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-envy-6555e-wireless',
      cover: '/printers/655e.jpeg',
      thumbnail: '',
      title: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      shortTitle: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      price: 139,
      badge: '',
      tags: ['Print', 'Scan', 'Copy'],
      descrition:
        'Perfect for home printing everyday documents, high quality photos, and borderless photos, homework, and borderless photos...',
      services_included: [],
      faqs: [],
    },
  ],
};

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
